import api from "./api";
import endpoints from "./endpoints";

export default {
  uploadEcfFile(path, overwrite, formdata) {
    return api
      .post(endpoints.files.upload, formdata, {
        params: { path, overwrite },
        headers: { "Content-Type": "multipart/form-data" }
      })
      .then((x) => Promise.resolve(x.data));
  }
};
